import { Button, HStack, Text, VStack } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

import { useMonitoringContext } from '../MonitoringContext';

export default function ComplexityFilter() {
  const { state, setShowChild, setShowParent } = useMonitoringContext();

  return (
    <VStack gap={2} paddingX={2} paddingY={3} alignItems="start" width="100%" backgroundColor="neutral.850">
      <Text fontWeight="medium" color="neutral.300">
        <FormattedMessage id="components.monitoring.filter.complexity" />
      </Text>
      <HStack width="100%" gap={1}>
        <Button
          variant="toggle"
          size="toggleM"
          flex={1}
          key="parent"
          data-active={state.showParent}
          onClick={() => setShowParent(!state.showParent)}
        >
          <FormattedMessage id="components.monitoring.filter.parent" />
        </Button>
        <Button
          variant="toggle"
          size="toggleM"
          flex={1}
          key="child"
          data-active={state.showChild}
          onClick={() => setShowChild(!state.showChild)}
        >
          <FormattedMessage id="components.monitoring.filter.child" />
        </Button>
      </HStack>
    </VStack>
  );
}
